import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full" data-testid="payment-cancel-card">
        <CardContent className="pt-8 pb-6 text-center">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto">
            <XCircle className="w-12 h-12 text-amber-600" />
          </div>
          <h1 className="mt-6 text-2xl font-bold text-slate-900" data-testid="cancel-title">
            Payment Cancelled
          </h1>
          <p className="mt-2 text-slate-600">
            Your payment was cancelled. No charges were made to your account.
          </p>
          <p className="mt-4 text-sm text-slate-500">
            You can still continue using nikosafe with your current plan.
            Upgrade anytime from your settings.
          </p>
          <div className="mt-8 space-y-3">
            <Link to="/settings">
              <Button className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="try-again-btn">
                Try Again
              </Button>
            </Link>
            <Link to="/dashboard">
              <Button variant="outline" className="w-full" data-testid="back-to-dashboard-btn">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Dashboard
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
